"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { Search, X } from "lucide-react";
import { useState, useEffect } from "react";

export default function ProductFilter() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const activeGender = searchParams.get("gender") || "all";
  const [searchTerm, setSearchTerm] = useState(searchParams.get("q") || "");

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const params = new URLSearchParams(searchParams.toString());
      if (searchTerm) {
        params.set("q", searchTerm);
      } else {
        params.delete("q");
      }
      router.push(`/products?${params.toString()}`);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  const updateFilter = (type: string, value: string) => {
    const params = new URLSearchParams(searchParams.toString());
    if (value === "all") {
      params.delete(type);
    } else {
      params.set(type, value);
    }
    router.push(`/products?${params.toString()}`);
  };

  return (
    <div className="space-y-8 mb-12 border-b border-[rgba(201,168,76,0.08)] pb-8">
      {/* Search Bar */}
      <div className="relative max-w-md group">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-[#7A7670] group-focus-within:text-[#C9A84C] transition-colors" size={18} />
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Parfüm ismi veya notası ara..."
          className="w-full bg-[#111114] border border-[rgba(201,168,76,0.12)] text-[#F4F0E8] pl-12 pr-10 py-3 rounded-full focus:outline-none focus:border-[#C9A84C] focus:bg-black/40 transition-all placeholder:text-[#7A7670]/50"
        />
        {searchTerm && (
          <button 
            onClick={() => setSearchTerm("")}
            className="absolute right-4 top-1/2 -translate-y-1/2 text-[#7A7670] hover:text-[#F4F0E8]"
          >
            <X size={16} />
          </button>
        )}
      </div>

      <div className="flex flex-wrap gap-12">
        <div className="space-y-3">
          <p className="text-[10px] text-[#7A7670] uppercase tracking-widest font-bold">Cinsiyet</p>
          <div className="flex flex-wrap gap-4">
            {["all", "ERKEK", "KADIN", "UNISEX"].map((gender) => (
              <button
                key={gender}
                onClick={() => updateFilter("gender", gender)}
                className={`text-xs uppercase tracking-widest transition px-3 py-1 rounded border ${
                  activeGender === gender ? "text-black bg-[#C9A84C] border-[#C9A84C]" : "text-[#7A7670] border-transparent hover:text-[#F4F0E8]"
                }`}
              >
                {gender === "all" ? "Tümü" : gender}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
